import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';

let tooltipId = 0;

export default function Tooltip({text, children}) {
    const triggerRef = useRef(null);
    const popupRef = useRef(null);
    const anchorNameRef = useRef(`--resume-tip-${++tooltipId}`);
    const [visible, setVisible] = useState(false);
    const [canUsePopover, setCanUsePopover] = useState(false);

    useEffect(() => {
        setCanUsePopover(
            typeof HTMLElement !== 'undefined'
            && typeof HTMLElement.prototype.showPopover === 'function'
            && typeof CSS !== 'undefined'
            && CSS.supports('top: anchor(top)'),
        );
    }, []);

    const show = () => setVisible(true);
    const hide = () => setVisible(false);

    useLayoutEffect(() => {
        const popup = popupRef.current;

        if (!popup || !canUsePopover) return undefined;

        if (!visible) {
            if (popup.matches(':popover-open')) {
                popup.hidePopover();
            }

            return undefined;
        }

        if (!popup.matches(':popover-open')) {
            popup.showPopover();
        }

        return () => {
            if (popup.matches(':popover-open')) {
                popup.hidePopover();
            }
        };
    }, [visible, canUsePopover]);

    return (
        <span
            className="resume-tip"
            ref={triggerRef}
            onMouseEnter={show}
            onMouseLeave={hide}
            style={canUsePopover ? {anchorName: anchorNameRef.current} : undefined}
        >
            {children ?? <i className="resume-tip__icon" aria-hidden="true" />}
            {visible && (
                <div
                    ref={popupRef}
                    className={`resume-tip__popup ${canUsePopover ? 'resume-tip__popup--popover' : ''}`}
                    popover={canUsePopover ? 'manual' : undefined}
                    role="tooltip"
                    style={canUsePopover ? {positionAnchor: anchorNameRef.current} : undefined}
                >
                    <div className="resume-tip__body">{text}</div>
                    <div className="resume-tip__arrow" />
                </div>
            )}
        </span>
    );
}
